import styled from "styled-components";

const StyledHowItWorks = styled.div`
  margin: 100px auto;
  max-width: 1200px;
  .howitworks__flex {
    display: flex;
    justify-content: space-around;
    align-items: center;
    > div {
      width: 40%;
    }
  }
`;

export default StyledHowItWorks;
